export const FORM_MODIFY_LOG = 'form_modify_log';
export const IMPORT_WF_DETAIL_MODAL = 'importWfDetailModal';
export const CHOOSE_EXCEPTION_OPERATOR = 'choose_exception_operator';
export const REJECT_CHOOSE = 'reject_choose';
export const OVERTIME_SETTING = 'overtime_setting';
export const HRM_EMPLOYEE_SETTING = 'HrmEmployeeSetting';
export const PRINT_LOG = 'print_log';
export const SEND_SMS = 'send_sms';
export const SEND_SMS_PARAMS = 'send_sms_params';
export const FREEFLOW_SETTING = 'freeflow_setting';
export const DO_SUPERVISE = 'do_supervise';
export const FORWARD_BACK = 'forward_back';
export const SELECT_NEXTFLOW = 'select_nextflow';
export const SELECT_NEXTFLOW_NODEINFO = 'select_nextflow_nodeinfo';
export const SHARE_WORKFLOW = 'share_workflow';
export const HANDLE_REMIND = 'handle_remind';
export const NEED_SHOW_CHART = 'need_show_chart';
export const SUBMIT_TYPE = 'submit_type';
export const LOCATION_MAP = 'location_map';
export const SEND_MAIL = 'send_mail';
export const SEND_MAIL_PARAMS = 'send_mail_params';
export const FREE_FLOW_SET = 'free_flow_set';
export const FREE_WORKFLOW_SIMPLE = 'free_workflow_simple';
export const ENSURE_SUBMIT = 'ensure_submit'; //流程提交二次确认
export const WORKFLOW_WITHDRAW = 'workflow_withdraw'; //流程撤回
export const FREE_FLOW_CHANGEFORM = 'free_flow_changeform';//自由流程自定义更换表单
export const FREE_FLOW_CHANGESTYLE = 'free_flow_changestyle';//自由流程自定义更换样式
export const CONFORM_RULE = 'conform_rule';



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/constants/type.js